export default class Header {

  constructor(el) {
    this.el = el
    this.hamburger = el.querySelector('.hamburger')
    this.hamburgerText = el.querySelector('.hamburger-text')
    this.menu = el.querySelector('.header--menu')
    this.nav = el.querySelector('.header--nav')
    this.colorIsPrimary = false
    this.colorObserver = null

    if (!this.hamburger) return

    this.bindHamburger()
    this.initColorPrimary()
    this.bindScroll()
  }

  isMenuOpen() {
    return this.menu?.classList.contains('is-full') ?? false
  }

  // Source de vérité unique pour l'état visuel du nav
  updateNavClasses() {
    if (this.isMenuOpen()) {
      this.nav.classList.add('is-white')
      this.nav.classList.remove('is-scrolled')
      return
    }

    // Sur une section .colored--primary, priorité au texte blanc (sans fond scrolled)
    if (this.colorIsPrimary) {
      this.nav.classList.add('is-white')
      this.nav.classList.remove('is-scrolled')
      return
    }

    // Sinon, comportement scroll : fond blanc + texte sombre passé 50px
    const scrolled = window.scrollY > 50
    this.nav.classList.toggle('is-scrolled', scrolled)
    this.nav.classList.remove('is-white')
  }

  initColorPrimary() {
    if (this.colorObserver) {
      this.colorObserver.disconnect()
      this.colorObserver = null
    }

    this.colorIsPrimary = false
    this.primarySectionsState = new Map()

    const sections = document.querySelectorAll('.colored--primary')
    if (!sections.length) {
      this.updateNavClasses()
      return
    }

    // Bande de détection : strip de 100px sous le top du viewport (zone du nav)
    this.colorObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          this.primarySectionsState.set(entry.target, entry.isIntersecting)
        })
        this.colorIsPrimary = [...this.primarySectionsState.values()].some(v => v)
        this.updateNavClasses()
      },
      { rootMargin: '0px 0px -90% 0px', threshold: 0 }
    )

    // État initial synchrone (avant que l'observer ne fire) pour éviter le flash
    sections.forEach(section => {
      const rect = section.getBoundingClientRect()
      const isIntersecting = rect.top < window.innerHeight * 0.1 && rect.bottom > 0
      this.primarySectionsState.set(section, isIntersecting)
    })
    this.colorIsPrimary = [...this.primarySectionsState.values()].some(v => v)

    sections.forEach(section => this.colorObserver.observe(section))

    this.updateNavClasses()
  }

  bindScroll() {
    window.addEventListener('scroll', () => this.updateNavClasses(), { passive: true })
    this.updateNavClasses()
  }

  bindHamburger() {
    this.hamburger.addEventListener('click', () => {
      const isOpen = this.hamburger.classList.toggle('is-active')
      this.menu?.classList.toggle('is-full')
      if (this.hamburgerText) this.hamburgerText.style.opacity = isOpen ? '0' : '1'

      if (isOpen) {
        window.lenis?.stop()
      } else {
        window.lenis?.start()
      }

      this.updateNavClasses()
    })
  }

}
